module.exports = __webpack_public_path__ + "img/autoParts.05fc5ce5.jpg";